<template>
  <AsyncComponentLoad v-if="!onReload"
                      v-bind="$attrs"
                      v-on="$listeners"></AsyncComponentLoad>
</template>

<script>
import AsyncComponentLoad from './AsyncComponentLoad'
export default {
  name: 'AsyncComponent',
  components: {
    AsyncComponentLoad
  },
  provide () {
    return {
      $async: this
    }
  },
  data () {
    return {
      onReload: false
    }
  },
  methods: {
    reload () {
      this.onReload = true
      this.$nextTick(() => {
        this.onReload = false
      })
    }
  }
}
</script>
